import HeaderParagraphsBlockView from '@src/components/battle/demo/blocks/HeaderParagraphsBlockView'
import ImageAndParagraphsBlockView from '@src/components/battle/demo/blocks/ImageAndParagraphsBlockView'
import ImageBlockView from '@src/components/battle/demo/blocks/ImageBlockView'
import IndexImageGridBlockView from '@src/components/battle/demo/blocks/IndexImageGridBlockView'
import LinkButtonView from '@src/components/battle/demo/blocks/LinkButtonView'
import ParagraphBlockView from '@src/components/battle/demo/blocks/ParagraphBlockView'
import PvpBuildExampleBlockView from '@src/components/battle/demo/blocks/PvpBuildExampleBlockView'
import RowBlockView from '@src/components/battle/demo/blocks/RowBlockView'
import SectionContainerBlockView from '@src/components/battle/demo/blocks/SectionContainerBlockView'
import SectionHeaderBlockView from '@src/components/battle/demo/blocks/SectionHeaderBlockView'
import YoutubeAutoplayBlockView from '@src/components/battle/demo/blocks/YoutubeAutoplayBlockView'
import YoutubeGridBlockView from '@src/components/battle/demo/blocks/YoutubeGridBlockView'
import { BlockType } from '@src/constants/pageBuilder'
import { Block } from '@src/types/pageBuilder'

type Props = {
  block: Block
}

const BlockView = ({ block }: Props) => {
  switch (block.type) {
    case BlockType.SectionHeader:
      return (
        <SectionHeaderBlockView title={block.value} variant={block.variant} />
      )
    case BlockType.Paragraph:
      return (
        <ParagraphBlockView
          href={block.href}
          layoutProps={block.layoutProps}
          text={block.value}
          variant={block.variant}
        />
      )
    case BlockType.ImageAndParagraphs:
      return (
        <ImageAndParagraphsBlockView
          href={block.value.href}
          image={block.value.imageSrc}
          layoutProps={block.layoutProps}
          paragraphBlocks={block.value.paragraphBlocks}
          title={block.value.header}
        />
      )
    case BlockType.HeaderParagraphs:
      return (
        <HeaderParagraphsBlockView
          href={block.value.href}
          title={block.value.header}
          paragraphBlocks={block.value.paragraphBlocks}
          layoutProps={block.layoutProps}
        />
      )
    case BlockType.SectionContainer:
      return (
        <SectionContainerBlockView layoutProps={block.layoutProps}>
          {block.children.map((child, index) => {
            const key = `${block.type}-${index}`

            return <BlockView key={key} block={child} />
          })}
        </SectionContainerBlockView>
      )
    case BlockType.ActionLink:
      return (
        <LinkButtonView href={block.value.href} title={block.value.title} />
      )
    case BlockType.Image:
      return (
        <ImageBlockView
          imgSrc={block.value.imageSrc}
          aspectRatio={block.layoutProps.aspectRatio}
          mobileAspectRatio={block.layoutProps.mobileAspectRatio}
        />
      )
    case BlockType.Row:
      return <RowBlockView cols={block.cols} />

    case BlockType.PvpBuildExample:
      return (
        <PvpBuildExampleBlockView
          previewSrc={block.value.previewImageSrc}
          apostles={block.value.apostles}
          layoutProps={block.layoutProps}
        />
      )
    case BlockType.IndexImageGrid:
      return (
        <IndexImageGridBlockView
          layoutProps={block.layoutProps}
          items={block.value.items}
        />
      )

    case BlockType.YoutubeGrid:
      return <YoutubeGridBlockView urls={block.value.urls} />

    case BlockType.YoutubeAutoplay:
      return (
        <YoutubeAutoplayBlockView
          autoplay={block.value.autoplay}
          layoutProps={block.layoutProps}
          url={block.value.url}
        />
      )
  }
}

export default BlockView
